import { Box, Text } from 'braid-design-system';
import React from 'react';

import * as styles from './index.css';

interface Props {
  labelOne: string;
  labelTwo: string;
  labelThree: string;
  labelFour: string;
}

export const ScaleLabel = ({
  labelOne,
  labelTwo,
  labelThree,
  labelFour,
}: Props) => (
  <Box display="flex" paddingTop="xsmall">
    <Box flexGrow={1} textAlign="left" paddingLeft="medium">
      <Text size="small">{labelOne}</Text>
    </Box>
    <Box textAlign="center" className={styles.middleValues}>
      <Text size="small">{labelTwo}</Text>
    </Box>
    <Box textAlign="center" className={styles.middleValues}>
      <Text size="small">{labelThree}</Text>
    </Box>
    <Box textAlign="right" flexGrow={1} paddingRight="medium">
      <Text size="small">{labelFour}</Text>
    </Box>
  </Box>
);
